import { QueryCriteria } from '../shared/components/filter-modals/query-criteria.model';

/**
 * CAPA 模块两个列表（CAPA 记录 / 发现项记录）的查询体构造。
 *
 * 这里的 columnName、operator、isValueADigital 必须与 PC 端保持一致：
 *   SCC_DES_Web/src/app/ehs/CAPA-Management/capa-record/services/capa-record.service.ts
 *   SCC_DES_Web/src/app/ehs/CAPA-Management/finding-record/services/finding-record.service.ts
 * 对照表见 docs/modules/capa-management.md 第 10.3 章。改这里之前先看那张表。
 */

const DEFAULT_PAGE_SIZE = 10;

function appendTextCriteria(list: any[], key: string, value: any): void {
  if (value) {
    list.push(new QueryCriteria(key, value, 'like'));
  }
}

function appendEqualCriteria(list: any[], key: string, value: any): void {
  if (value) {
    list.push(new QueryCriteria(key, value, '='));
  }
}

function appendInCriteria(list: any[], key: string, value: any): void {
  if (value) {
    list.push(new QueryCriteria(key, value, 'in'));
  }
}

function appendDigitalCriteria(list: any[], key: string, value: any): void {
  if (value) {
    list.push(new QueryCriteria(key, value, '=', 'and', true));
  }
}

function appendDateCriteria(list: any[], key: string, value: any, condition: string): void {
  if (value) {
    list.push(new QueryCriteria(key, value, condition));
  }
}

/** 结案日期这类只比日期不比时间的条件，先截成 yyyy-MM-dd */
function formatDateOnly(value: any): any {
  if (!value) {
    return value;
  }

  if (typeof value === 'string') {
    return value.substring(0, 10);
  }

  if (value instanceof Date) {
    const year = value.getFullYear();
    const month = ('0' + (value.getMonth() + 1)).slice(-2);
    const day = ('0' + value.getDate()).slice(-2);
    return year + '-' + month + '-' + day;
  }

  return value;
}

export function buildCapaRecordQuery(query: any, pageSize?: number): any {
  query = query || {};
  const queryCriterias = [];
  appendTextCriteria(queryCriterias, 'code', query.recordNo);
  appendTextCriteria(queryCriterias, 'subject', query.title);
  appendDigitalCriteria(queryCriterias, 'orgId', query.factoryId);
  appendDateCriteria(queryCriterias, 'executionDate', query.execDateFrom, '>=');
  appendDateCriteria(queryCriterias, 'executionDate', query.execDateTo, '<=');
  appendEqualCriteria(queryCriterias, 'capaSourceId', query.capaSourceId);
  appendEqualCriteria(queryCriterias, 'reportedById', query.reportedById);
  appendDateCriteria(queryCriterias, 'reportDate', query.reportDateFrom, '>=');
  appendDateCriteria(queryCriterias, 'reportDate', query.reportDateTo, '<=');
  appendEqualCriteria(queryCriterias, 'finalVerifierId', query.finalVerifierId);
  appendDateCriteria(queryCriterias, 'endDate', query.dueDateFrom, '>=');
  appendDateCriteria(queryCriterias, 'endDate', query.dueDateTo, '<=');
  appendEqualCriteria(queryCriterias, 'currentExecutorId', query.currentExecutorId);
  appendInCriteria(queryCriterias, 'status', query.status);
  return {
    pagingTool: {
      currentPage: query.currentPage || 1,
      pageSize: query.pageSize || pageSize || DEFAULT_PAGE_SIZE,
    },
    queryOrderBies: [{ columnName: 'reportDate', orderType: 'DESC' }],
    queryCriterias: queryCriterias,
    params: {},
  };
}

export function buildFindingsRecordQuery(query: any, pageSize?: number): any {
  query = query || {};
  const queryCriterias = [];
  appendTextCriteria(queryCriterias, 'code', query.recordNo);
  appendTextCriteria(queryCriterias, 'actionItemCode', query.findingNo);
  appendTextCriteria(queryCriterias, 'capaCode', query.capaCode);
  appendEqualCriteria(queryCriterias, 'capaSourceId', query.capaSourceId);
  appendTextCriteria(queryCriterias, 'actionItemDescription', query.description);
  appendTextCriteria(queryCriterias, 'auditItemDetail', query.evidence);
  appendTextCriteria(queryCriterias, 'mainProcess', query.mainProcess);
  appendTextCriteria(queryCriterias, 'subProcess', query.subProcess);
  appendTextCriteria(queryCriterias, 'chargeDepartment', query.chargeDepartment);
  appendEqualCriteria(queryCriterias, 'chargePerson', query.chargePersonId);
  appendEqualCriteria(queryCriterias, 'reviewer', query.reviewerId);
  appendEqualCriteria(queryCriterias, 'verifier', query.verifierId);
  appendDateCriteria(queryCriterias, 'endDate', query.dueDateFrom, '>=');
  appendDateCriteria(queryCriterias, 'endDate', query.dueDateTo, '<=');
  appendEqualCriteria(queryCriterias, 'currentExecutorId', query.currentExecutorId);
  appendInCriteria(queryCriterias, 'status', query.status);
  appendEqualCriteria(queryCriterias, 'completionStatus', query.completionStatus);
  appendDateCriteria(queryCriterias, 'closureDate', formatDateOnly(query.closureDateFrom), '>=');
  appendDateCriteria(queryCriterias, 'closureDate', formatDateOnly(query.closureDateTo), '<=');
  return {
    pagingTool: {
      currentPage: query.currentPage || 1,
      pageSize: query.pageSize || pageSize || DEFAULT_PAGE_SIZE,
    },
    queryOrderBies: [{ columnName: 'reportDate', orderType: 'DESC' }],
    queryCriterias: queryCriterias,
    params: {},
  };
}
